import { Link, Navigate, useSearchParams } from 'react-router-dom'
import { useAuth } from '@context/AuthContext'
import DeadlineRagIndexPanel from '@components/deadline-simulator/components/DeadlineRagIndexPanel'
import PecasAcervoPanel from './PecasAcervoPanel'
import PanaceiaTestPanel from './PanaceiaTestPanel'
import JurisprudenceProvidersPanel from './JurisprudenceProvidersPanel'
import './baseJuridicaSettings.css'

export default function BaseJuridicaSettingsPage() {
  const { canManageLegalTemplates, canManageSimulatorSettings } = useAuth()
  const [searchParams] = useSearchParams()
  const sections = [
    canManageLegalTemplates && { id: 'pecas', label: 'Peças do escritório', icon: 'fa-folder-open' },
    canManageLegalTemplates && { id: 'testar', label: 'Testar PanaceIA', icon: 'fa-wand-magic-sparkles' },
    canManageLegalTemplates && { id: 'integracoes', label: 'Integrações de jurisprudência', icon: 'fa-plug' },
    canManageSimulatorSettings && { id: 'referencias', label: 'Referências do motor', icon: 'fa-book-open' },
  ].filter(Boolean)
  const requestedSection = searchParams.get('secao')
  const activeSection = sections.find((section) => section.id === requestedSection) || sections[0]

  if (!activeSection) return null
  if (requestedSection && requestedSection !== activeSection.id)
    return <Navigate to={`?secao=${activeSection.id}`} replace />

  return (
    <div className="main-content rules-config-page base-juridica-settings">
      <nav className="rules-tabs base-juridica-sections" aria-label="Seções da configuração da base jurídica">
        {sections.map((section) => (
          <Link key={section.id} id={`base-juridica-section-${section.id}`}
            to={`?secao=${section.id}`}
            className={`rules-tab ${activeSection.id === section.id ? 'active' : ''}`}
            aria-current={activeSection.id === section.id ? 'page' : undefined}>
            <i className={`fas ${section.icon}`} aria-hidden="true" />
            {section.label}
          </Link>
        ))}
      </nav>

      <section className="base-juridica-section" aria-labelledby={`base-juridica-section-${activeSection.id}`}>
        {activeSection.id === 'pecas' && canManageLegalTemplates ? <PecasAcervoPanel /> : null}
        {activeSection.id === 'testar' && canManageLegalTemplates ? <PanaceiaTestPanel /> : null}
        {activeSection.id === 'integracoes' && canManageLegalTemplates ? <JurisprudenceProvidersPanel /> : null}
        {activeSection.id === 'referencias' && canManageSimulatorSettings ? (
          <section className="rules-card">
            <div className="rules-card-header">
              <div>
                <h2>Referências do motor</h2>
                <p>Consulte a cobertura e indexe as fontes utilizadas na revisão das análises de prazos.</p>
              </div>
            </div>
            <div className="rules-card-body"><DeadlineRagIndexPanel /></div>
          </section>
        ) : null}
      </section>
    </div>
  )
}
